import { render, staticRenderFns } from "./EnderecosCadastrar.vue?vue&type=template&id=bb8be00c&scoped=true"
import script from "./EnderecosCadastrar.vue?vue&type=script&lang=js"
export * from "./EnderecosCadastrar.vue?vue&type=script&lang=js"
import style0 from "./EnderecosCadastrar.vue?vue&type=style&index=0&id=bb8be00c&prod&lang=scss&scoped=true"
import style1 from "./EnderecosCadastrar.vue?vue&type=style&index=1&id=bb8be00c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8be00c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VIcon,VSelect,VTextField})
